module.exports = __webpack_public_path__ + "img/img-organizations.b83bc46c.svg";